import { render, staticRenderFns } from "./RiskAssessmentFirst.vue?vue&type=template&id=42b5d2f2&scoped=true&"
import script from "./RiskAssessmentFirst.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5d2f2",
  null
  
)

export default component.exports